module.exports = __webpack_public_path__ + "arrow-prev@2x.jpg?b84a205d823bd19d5466fb63551c86cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-prev@2x.jpg
// module id = 157
// module chunks = 0